import React from 'react';

import { Block } from '../common/Block.jsx';
import { Clickable, Hoverable } from '../common/Button.jsx';
import { Column, Row } from '../common/Container.jsx';
import Defaults from '../layout/Defaults.jsx';
import { FormContainer } from '../common/Form.jsx';
import FormField from '../common/FormField.jsx';
import { Text, Wrapper as InputWrapper } from '../common/Input.jsx';
import Name from '../common/Name.jsx';

// region PROMO CODE V1 (-- DEPRECATED Use `PromoCodeV2` --)

function PromoCodeV1Component(props) {
    // Promo Code
    const [promoCode, setPromoCode] = React.useState({ state: 'form' });
    const handlePromoCodeChange = (_, value) => {
        setPromoCode({ entry: value, state: promoCode.state });
    }
    const handlePromoCodeSubmit = () => {
        if (props.disabled || !promoCode.entry) {
            return;
        }
        setPromoCode({ entry: promoCode.entry, state: 'processing' });

        $.get(
            `/api/promoCodes/${promoCode.entry}`,
            { sub: props.config.subdomain },
            (responseData) => {
                if (responseData.isValid) {
                    if (!props.builder) {
                        cart.setPromoCode(responseData.promoCodeId);
                    }    
                    if (props.onRefreshCart) {
                        props.onRefreshCart({ promoCodeId: responseData.promoCodeId });
                    }
                    setPromoCode({ state: 'form' });
                } else {
                    setPromoCode({ entry: promoCode.entry, error: responseData.message, state: 'error' });
                }
            }).fail(() => {
                setPromoCode({ entry: promoCode.entry, error: 'Sorry, this promotion code is not valid.', state: 'error' })
            });
    }
    if (!props.builder && (!props.hasActivePromoCodes || props.checkoutComplete)) {
        return null;
    }
    const buttonWrapperStyle = { width: '43%' }
    const inputWrapperStyle = { marginRight: '20px', width: '57%' };
    let buttonHoverProps, buttonStyle, buttonText, inputStyle;
    if (props.blockConfig) {
        if (props.blockConfig.button) {
            buttonStyle = {};
            Block.mapStyleConfigProps(buttonStyle, props.blockConfig.button, (propName, propValue, propUnit) => {

                switch (propName) {
                    case 'text':
                        buttonText = propValue;
                        return true;
                    case 'width':
                        if (propValue && propUnit) {
                            buttonWrapperStyle.width = `${propValue}${propUnit}`;
                        }
                        return true;
                    default:
                        let _propValue = propValue;
                        if (_propValue && propUnit) {
                            _propValue = `${_propValue}${propUnit}`;
                        }
                        if (propName.indexOf('Hover') < 0 || !_propValue) {
                            break;
                        }
                        if (!buttonHoverProps) {
                            buttonHoverProps = {};
                        }
                        const _propName = propName.replace('Hover', '');
                        buttonHoverProps[_propName] = _propValue;
                        return true;
                }
            });
        }
        if (props.blockConfig.input) {
            inputStyle = {};
            Block.mapStyleConfigProps(inputStyle, props.blockConfig.input, (propName, propValue, propUnit) => {
                switch (propName) {
                    case 'lineSpacing':
                        if (propValue && propUnit) {
                            inputWrapperStyle.marginRight = `${propValue}${propUnit}`;
                        }
                        return true;
                    case 'width':
                        if (propValue && propUnit) {
                            inputWrapperStyle.width = `${propValue}${propUnit}`;
                        }
                        return true;
                }
            });
        }
    }
    const disabled = props.builder == true || props.disabled == true || promoCode.state == 'processing';
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit({}, props);
    if (props.builder || disabled) {
        layoutStyles.style.pointerEvents = 'none';
    }
    let className = 'form form--contact form--whitelabel__v1';
    if (!props.inLayout) {
        className += ' cont--kit__content';
    }
    let ButtonComponent = Clickable;
    if (buttonHoverProps != undefined) {
        ButtonComponent = Hoverable;
    }
    if (props.disabled) {
        layoutStyles.style.pointerEvents = 'none';
    }
    let content = (
        <form className={className} id="promoCodeForm" style={layoutStyles.style}>
            <div style={{ display: 'flex' }}>
                <InputWrapper size="small" style={inputWrapperStyle}>
                    <Text
                        disabled={disabled}
                        name="code"
                        placeholder="Promo Code"
                        type="text"
                        style={inputStyle}
                        value={promoCode.entry}
                        onChange={handlePromoCodeChange} />
                </InputWrapper>
                <div style={buttonWrapperStyle}>
                    <ButtonComponent
                        className={`btn btn--fill input${promoCode.state == 'processing' ? ' btn--processing' : ''}`}
                        disabled={disabled}
                        hoverProps={buttonHoverProps}
                        style={buttonStyle}
                        type="submit"
                        onClick={handlePromoCodeSubmit}>
                        <React.Fragment><div className="submission-status" /> {buttonText || 'APPLY'}</React.Fragment>
                    </ButtonComponent>
                </div>
            </div>
            {
                promoCode.error &&
                <Row>
                    <Column id="promoCodeErrorContainer" size="12" style={{ paddingTop: '20px' }}>
                        <p className="error">{promoCode.error}</p>
                    </Column>
                </Row>
            }
        </form>
    );
    if (layoutStyles.containerStyle) {
        if (props.inLayout) {
            layoutStyles.containerStyle.width = '100%';
        }
        content = <div className="cont--kit__wrapper" style={layoutStyles.containerStyle}>{content}</div>
    }
    return content;
}
const PromoCodeV1 = { Component: PromoCodeV1Component };

// region PROMO CODE V2

function PromoCodeV2Component(props) {
    const [promoCode, setPromoCode] = React.useState({ formState: 'form' });
    const handleChange = (_, value) => {
        setPromoCode({ entry: value, formState: promoCode.formState });
    }
    const handlePromoCodeSubmit = () => {
        if (props.disabled || !promoCode.entry) {
            return;
        }
        setPromoCode({ entry: promoCode.entry, formState: 'processing' });

        $.get(
            `/api/promoCodes/${promoCode.entry}`,
            { sub: props.config.subdomain },
            (responseData) => {
                if (responseData.isValid) {
                    if (!props.builder) {
                        cart.setPromoCode(responseData.promoCodeId);
                    }
                    if (props.onRefreshCart) {
                        props.onRefreshCart({ promoCodeId: responseData.promoCodeId });
                    }
                    setPromoCode({ formState: 'form' });
                } else {
                    setPromoCode({ entry: promoCode.entry, error: responseData.message, formState: 'error' });
                }
            }).fail(() => {
                setPromoCode({ entry: promoCode.entry, error: 'Sorry, this promotion code is not valid.', formState: 'error' })
            });
    }
    if (!props.builder && !props.hasActivePromoCodes) {
        return null;
    }
    const handleFormFieldProps = ({ type }, formFieldProps) => {
        switch (type) {
            case FormField.Code:
                formFieldProps.placeholderText = 'Promo Code';
                formFieldProps.onSubmit = handlePromoCodeSubmit;
                break;
            case FormField[Name.Block.Cart.PromoCode.Container].ErrorMessage:
                formFieldProps.editor = props.editor;
                formFieldProps.error = promoCode.error;
                break;
            case FormField[Name.Block.Cart.PromoCode.Container].SubmitButtonV1:
            case FormField[Name.Block.Cart.PromoCode.Container].SubmitButtonV2:
                formFieldProps.formState = promoCode.formState;
                formFieldProps.onClick = handlePromoCodeSubmit;
                break;
        }
    }
    let contentConfig = props.contentConfig;
    if (!contentConfig) {
        if (props.blockConfig && props.blockConfig.layout && props.blockConfig.layout.design && props.blockConfig.layout.design.desktop && props.blockConfig.layout.design.desktop.blocks && props.blockConfig.layout.design.desktop.blocks.length > 0) {
            contentConfig = props.blockConfig.layout.design;
        } else {
            contentConfig = Defaults.Block[Name.Block.Cart.PromoCode.Container];
        }
    }
    let contentProps;
    if (!props.editor) {
        contentProps = { id: 'promoCodeForm' }
    }
    return (
        <FormContainer.Component
            {...props}
            contentConfig={contentConfig}
            contentProps={contentProps}
            formData={{ code: promoCode.entry, formState: promoCode.formState }}
            onChange={handleChange}
            onFormFieldProps={handleFormFieldProps} />
    );
}
const PromoCodeV2 = { Component: PromoCodeV2Component };

export {
    PromoCodeV2,

    // DEPRECATED
    PromoCodeV1
}
